<div class="send-sms-page">
  <div class="title">
    <p class="vox-heading-2" translate>sales.send-sms.title</p>
  </div>
  <hr />
  <form [formGroup]="sendSmsForm" (ngSubmit)="sendSms()" class="form-container">
    <div class="row">
      <div class="col-sm col-md-5">
        <label for="recipient" translate>sales.send-sms.form.recipient.label</label>
        <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isInvalid('recipient')}">
          <vox-phone-text-field [dense]="true" formControlName="recipient" state="it"
            [ngClass]="{'was-validated': isInvalid('recipient')}">
          </vox-phone-text-field>
          <span class="vox-input-group__error-message" *ngIf="getControl('recipient').errors?.required"
            translate>sales.send-sms.form.error</span>
          <span class="vox-input-group__error-message" *ngIf="getControl('recipient').errors?.error"
            translate>sales.send-sms.errors.bad-number</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm col-md-5">
        <label for="message" translate>sales.send-sms.form.message.label</label>
        <div class="vox-input-group" [ngClass]="{'vox-input-group_invalid': isInvalid('message')}">
          <textarea class="vox-text-field" type="text" id="message" rows="5"
            placeholder="{{ 'sales.send-sms.form.message.placeholder' | translate }}"
            formControlName="message"></textarea>
          <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
          <span class="vox-input-group__error-message" *ngIf="getControl('message').errors?.required"
            translate>sales.send-sms.form.error</span>
        </div>
      </div>
    </div>
    <div class="submit-container">
      <button class="vox-btn vox-btn-primary" type="submit" [ladda]="loading" [disabled]="sendSmsForm.invalid">
        {{'sales.send-sms.form.button' | translate}}
      </button>
    </div>
  </form>
</div>